import { render, staticRenderFns } from "./PageFooterCom.vue?vue&type=template&id=3444d745&scoped=true"
var script = {}
import style0 from "./PageFooterCom.vue?vue&type=style&index=0&id=3444d745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444d745",
  null
  
)

export default component.exports